import { BookOpenCheck } from "lucide-react";
import { theme } from "../theme";
import { playbookForCriterion, playbookPath, usePlaybooks } from "../lib/playbooks";
import { ShellLink } from "./ShellLink";

/**
 * The good-practice criteria a compliance verdict relied on, each linked to its playbook in
 * Help. A criterion the catalogue no longer carries (a stored run from an older release) is
 * shown as plain text rather than dropped.
 */
export function PlaybookCriteriaChips({ ids }: { ids: string[] }) {
  const list = usePlaybooks();
  return (
    <div style={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 6, marginBottom: 10 }}>
      <span style={{ fontSize: 10, fontWeight: 700, color: theme.color.muted, textTransform: "uppercase", letterSpacing: "0.04em" }}>
        Good practice
      </span>
      {ids.map((id) => {
        const pb = list ? playbookForCriterion(list, id) : undefined;
        const chip = {
          display: "inline-flex", alignItems: "center", gap: 4, fontSize: 11, padding: "2px 8px", borderRadius: 999,
          border: `1px solid ${theme.color.border}`, color: theme.color.accentText, background: theme.color.panelAlt, textDecoration: "none",
        } as const;
        return pb
          ? <ShellLink key={id} to={playbookPath(pb.id)} style={chip} title={`Open the ${pb.title} playbook`}><BookOpenCheck size={12} />{id} · {pb.title}</ShellLink>
          : <span key={id} style={chip}>{id}</span>;
      })}
    </div>
  );
}
